import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from '@/routes/api/api_conextion';
export function checkCode(params) {
  return request({
    url: '/formulario/controlCodigo',
    method: 'get',
    params: params
  });
}
export function resendVerificationCode(code) {
  return request({
    url: '/formulario/enviarCodigo/' + code,
    method: 'put'
  });
}
export function getOferta(id_solicitud, params) {
  return request({
    url: "/formulario/proposal/" + id_solicitud,
    method: 'get',
    params: params
  });
}
export function addGarante(params) {
  return request({
    url: "/formulario/garante/" + params.loan,
    method: 'post',
    data: params
  });
}
export function aceptOferta(params) {
  return request({
    url: "/formulario/accept",
    method: 'post',
    data: params
  });
}
export function segundoFormularioConsumo(params) {
  return request({
    url: "/formulario/" + params.loan,
    method: 'put',
    data: params
  });
}
export function getParametersToAccomplish() {
  return request({
    url: '/formulario/getParametersToAccomplish',
    method: 'get'
  });
}
export function simularCustom(params) {
  return request({
    url: '/formulario/simularFront',
    method: 'post',
    data: params
  });
}
export function getProduct(_x) {
  return _getProduct.apply(this, arguments);
}
function _getProduct() {
  _getProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(product_id) {
    var number_step,
      garante,
      formato_documento,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          number_step = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
          garante = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
          formato_documento = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
          return _context.a(2, request({
            url: "/loancustom/" + product_id,
            method: 'get',
            params: {
              step: number_step,
              garante: garante,
              formato_documento: formato_documento
            }
          }));
      }
    }, _callee);
  }));
  return _getProduct.apply(this, arguments);
}
export function getAllProfiles(params) {
  return request({
    url: "/loancustom/all/" + params.type,
    method: 'get'
  });
}
export function getCotizacionDia(params) {
  return request({
    url: "/cotizacion/cambioventa/" + params.id,
    method: 'get'
  });
}
export function addLoanCustom(params) {
  return request({
    url: "/formulario",
    method: 'post',
    data: params
  });
}
export function addPymeComponent(params) {
  return request({
    url: "/formulario/addPymeComponent/" + params.loan,
    method: 'post',
    data: params
  });
}
export function getDocumentacion(params) {
  return request({
    url: "/getdocumentacion/" + params.id + '/' + params.type,
    method: 'get'
  });
}
export function setApplicant(params) {
  return request({
    url: '/formulario/applicant',
    method: 'post',
    data: params
  });
}
export function getProductStep(params) {
  return request({
    url: 'product/step',
    method: 'post',
    data: params
  });
}
export function checkApplicant(params) {
  return request({
    url: '/checkApplicantActive',
    method: 'post',
    data: params
  });
}
export function getCalcularLimite(params) {
  return request({
    url: '/getCalcularLimite',
    method: 'post',
    data: params
  });
}
export function checkEquifax(params) {
  return request({
    url: '/checkApplicantFinal',
    method: 'post',
    data: params
  });
}
export function getPrestamo(loan) {
  return request({
    url: "/formulario/getprestamo/" + loan,
    method: 'get'
  });
}
export function confirmacionPago(params) {
  return request({
    url: '/confirmacion/pago',
    method: 'post',
    data: params
  });
}
export function checkFinal(params) {
  return request({
    url: '/checkSolicitudFinal',
    method: 'post',
    data: params
  });
}
export function getConfigSimulador(params) {
  return request({
    url: '/product/config',
    method: 'post',
    data: params
  });
}
export function getDetalleOferta(params) {
  return request({
    url: "/getdetalleoferta",
    method: 'post',
    data: params
  });
}
export function validateMontoAPrestar(producto, montoPrestamo, lineaOtorgar) {
  var params = {
    producto: producto,
    monto: montoPrestamo,
    linea: lineaOtorgar
  };
  return request({
    url: "/validateMontoAPrestar",
    method: 'post',
    data: params
  });
}
export function setInversores(params) {
  return request({
    url: '/formulario/setInversores',
    method: 'post',
    data: params
  });
}